import { CrewChangeRequestFilterByEnum } from '@bechtel/types';
import { CrewChangeRequestFilter } from './types';
import { t } from '@lingui/macro';
export const filters: CrewChangeRequestFilter[] = [
  { id: 1, value: CrewChangeRequestFilterByEnum.ALL, label: t`All`, total: 0 },
  { id: 2, value: CrewChangeRequestFilterByEnum.PENDING_APPROVAL, label: t`Pending`, total: 0 },
  { id: 3, value: CrewChangeRequestFilterByEnum.CLOSED, label: t`Closed - Last 7 Days`, total: 0 },
];
